import React, { useState } from "react";
import {
  Drawer,
  Form,
  Button,
  Input,
  Switch,
  message,
  Select,
  notification,
} from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { API, Headers } from "../../Config";
import axios from "axios";
import styles from "./styles";
var width = window.innerWidth;
var innerwidth = window.innerWidth <= 760;
const { Option } = Select;
function FormModal(props) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    let obj = {
      name: values.name,
      office_address: values.office_address,
      type: values.type,
      country_id: Number(values.country_id),
      place: values.place,
      mobile: values.mobile,
      active: values.active,
    };
    let URL =
      props.mode === "post"
        ? API.BRANCHES_ACTION
        : API.BRANCHES_ACTION + props.item.id;
    axios({
      method: props.mode,
      url: API.BASR_URL + URL,
      headers: Headers(),
      data: obj,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onchange();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
        notification.open({
          message: "ERROR",
          description: `${error.response.data.message}`,
        });
      });
  };

  return (
    <Drawer
      placement={props.mode === "post" ? "right" : "left"}
      title={
        <span className="txt4">
          {props.mode === "post" ? "New" : "Update"} Branches
        </span>
      }
      width={innerwidth ? width : width / 2.7}
      onClose={() => props.onClose()}
      visible={props.visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        layout="vertical"
        hideRequiredMark
        onFinish={onFinish}
        initialValues={{
          name: props.item && props.item.name,
          office_address: props.item && props.item.office_address,
          type: props.item && props.item.type,
          country_id: props.item && props.item.country_id,
          place: props.item && props.item.place,
          mobile: props.item && props.item.mobile,
          active: props.item && props.item.active ? props.item.active : false,
        }}
      >
        <Container>
          <Row>
            <Col sm="6" xs="12">
              <Form.Item
                name="name"
                label={<div className="form-item-label">Name</div>}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="Enter Name" style={styles.FormInput} />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="place"
                label={<div className="form-item-label">Place</div>}
              >
                <Input placeholder="Enter Place" style={styles.FormInput} />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="type"
                label={<div className="form-item-label">Type</div>}
                rules={[{ required: true, message: "required" }]}
              >
                <Select placeholder="select Type" style={styles.FormInput}>
                  <Option value={"pickup"}>Pickup</Option>
                  <Option value={"delivery"}>Delivery</Option>
                  <Option value={"process"}>Process</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="country_id"
                label={<div className="form-item-label">Country</div>}
                rules={[{ required: true, message: "required" }]}
              >
                <Select
                  placeholder="Select Country"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={styles.FormInput}
                >
                  {props.countries.map((option) => (
                    <Option key={option.code}>{option.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="mobile"
                label={<div className="form-item-label">Contact Number</div>}
              >
                <Input placeholder="Enter Number" />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12"></Col>
            <Col sm="12" xs="12">
              <Form.Item
                name="office_address"
                label={<div className="form-item-label">Address</div>}
              >
                <Input.TextArea
                  placeholder="Enter Address"
                  style={styles.FormInput}
                />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                label={<div className="form-item-label">Active</div>}
                name="active"
                rules={[{ required: true, message: "required" }]}
                valuePropName={props.item.active ? "checked" : "uncheked"}
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {props.mode === "post" ? null : <Col sm="6" xs="12"></Col>}
            <Col sm="6" xs="12">
              <Row>
                <Col sm="6" xs="12">
                  <Button onClick={() => props.onClose()} block>
                    Cancel
                  </Button>
                </Col>
                <Col sm="6" xs="12">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Form>
    </Drawer>
  );
}
export default FormModal;
